import React from 'react';

import tiLogoSmall from 'images/TheInformationLogo.png';

import FlexLink from '@components/FlexLink';
import { useAppContext } from '@contexts/AppContext';
import { useCurrentUser } from '@hooks';
import { edit_profile_settings_path, logout_path } from '@routes';

import { userName, userTitle } from '../User/userHelpers';

export default function CommentFormHeader({
  isEditing,
  isReplyForm,
  hideReplyForm,
  hideEditForm,
}: {
  isEditing?: boolean;
  isReplyForm?: boolean;
  hideReplyForm?: () => void;
  hideEditForm?: () => void;
}) {
  const { isWebview } = useAppContext();
  const { currentUser } = useCurrentUser();
  const name = userName(currentUser);

  const hideForm = () => {
    if (isReplyForm) {
      hideReplyForm();
    } else if (isEditing) {
      hideEditForm();
    }
  };

  return (
    <>
      <div className="comment-header">
        {!isEditing && (
          <div className="comment-avatar-link">
            {currentUser?.picture_url ? (
              <img src={currentUser.picture_url} alt={name} className="comment-avatar" />
            ) : (
              <div className="comment-avatar">
                <div className="comment-avatar-placeholder">{name.toUpperCase()}</div>
              </div>
            )}
          </div>
        )}
        <div className="comment-author">
          <div className="comment-author-name">
            <span className="quiet-link">{name}</span>
            {currentUser?.administrator?.is_active && (
              <img src={tiLogoSmall} className="comment-staff-logo" />
            )}
          </div>
          <div className="comment-author-title">{userTitle(currentUser)}</div>
        </div>
        {isReplyForm || isEditing ? (
          <button className="close-reply-btn fa fa-times" onClick={hideForm} />
        ) : (
          <div className="comment-header-right hidden sm:block">
            <div className="header-text-action">
              Not you?{' '}
              <a className="logout" href={logout_path()}>
                Sign out
              </a>
            </div>
            <div className="header-text-action">
              Want to edit your profile?{' '}
              <FlexLink href={edit_profile_settings_path()} toRailsPage>
                Edit Profile
              </FlexLink>
            </div>
          </div>
        )}
      </div>
      {!isWebview && !isReplyForm && (
        <div className="mb1 block sm:hidden">
          <div className="header-text-action">
            Not you?{' '}
            <FlexLink href={logout_path()} toRailsPage>
              Sign out
            </FlexLink>
          </div>
          <div className="header-text-action">
            Want to edit your profile?{' '}
            <FlexLink href={edit_profile_settings_path()} toRailsPage>
              Edit Profile
            </FlexLink>
          </div>
        </div>
      )}
    </>
  );
}
